"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.megabyte = exports.kilobyte = exports.zero = exports.tenThousand = exports.oneThousand = exports.oneHundred = exports.fifty = exports.thirty = exports.twenty = exports.eighteen = exports.fifteen = exports.thirteen = exports.twelve = exports.ten = exports.nine = exports.seven = exports.five = exports.three = exports.two = exports.one = void 0;
exports.one = 1;
exports.two = 2;
exports.three = 3;
exports.five = 5;
exports.seven = 7;
exports.nine = 9;
exports.ten = 10;
exports.twelve = 12;
exports.thirteen = 13;
exports.fifteen = 15;
exports.eighteen = 18;
exports.twenty = 20;
exports.thirty = 30;
exports.fifty = 50;
exports.oneHundred = 100;
exports.oneThousand = 1000;
exports.tenThousand = 10000;
exports.zero = 0;
exports.kilobyte = 1024;
exports.megabyte = exports.kilobyte * exports.kilobyte;
